import React from "react";
import { CircleCheckIcon, MessageCircleIcon, BoxIcon } from "lucide-react";
import { Reveal } from "./Reveal";
import { freeCallPoints } from "../data/homepage";
const icons = [MessageCircleIcon, BoxIcon, CircleCheckIcon];
export function FreeCallBox() {
  return <section aria-labelledby="free-call-heading" className="on-light bg-paper pb-24 pt-12 md:pb-32" data-id="element-75" data-mp="zlozfpmjxima">
      <Reveal className="mx-auto max-w-3xl px-6" data-id="element-76" data-mp="14k8ow00ctcje">
        <div className="rounded-sm border border-navy/10 bg-[#EFEAE0] p-8 md:p-12" data-id="element-77" data-mp="psghca6sx2s8">
          <h2 id="free-call-heading" className="font-serif text-3xl font-semibold leading-tight text-navy md:text-4xl" data-id="element-78" data-mp="ukhqvocl4fek">
            What happens on the free call
          </h2>
          <div aria-hidden="true" className="mt-6 h-px w-16 bg-gold" data-id="element-79" data-mp="lro9nldkv5y2" />
          <ul className="mt-8 space-y-6" data-id="element-80" data-mp="lptny4uhf9sx">
            {freeCallPoints.map((point, i) => {
            const Icon = icons[i];
            return <li key={point.lead} className="flex items-start gap-4" data-id="element-81" data-mp="btgu96yxsvy6" data-mpi={i}>
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-82" data-mp="bvkwzll3nowv">
                    <Icon aria-hidden="true" className="h-5 w-5 text-gold" strokeWidth={1.75} data-id="element-83" data-mp="y9n5c8towqbw" />
                  </span>
                  <p className="text-lg leading-relaxed text-charcoal md:text-xl" data-id="element-84" data-mp="1c9xwze2tq8y4">
                    <strong className="font-semibold text-navy" data-id="element-85" data-mp="18843pquyk77z">{point.lead}</strong> {point.rest}
                  </p>
                </li>;
          })}
          </ul>
        </div>
      </Reveal>
    </section>;
}